import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreateProfile = _resolveComponent("CreateProfile")!
  const _component_BlockMaxWidthHandler = _resolveComponent("BlockMaxWidthHandler")!

  return (_openBlock(), _createBlock(_component_BlockMaxWidthHandler, null, {
    default: _withCtx(() => [
      _createVNode(_component_CreateProfile, {
        class: "mx-auto max-w-500",
        stores: _ctx.content.stores,
        "redirect-link": _ctx.content.redirectAfterCreateProfileLink
      }, null, 8, ["stores", "redirect-link"])
    ]),
    _: 1
  }))
}